import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class FilterItem extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    filter: PropTypes.object
  };

  static defaultProps = {
    filter: {}
  };

  handleClick = () => this.props.onClick(this.props.filter.value);

  render() {
    return (
      <span className="sorted-list__filter">
        {this.props.filter.label}
        <button className="sorted-list__delete-filter" onClick={this.handleClick}>
          x
        </button>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/FilterItem.js